import axios from "axios";

/**
 * Instancia global de Axios pre-configurada apuntando al Backend en Go (`REACT_APP_API_URL`).
 * Reemplaza la necesidad de llamar manualmente al FQDN completo en cada endpoint.
 */
const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
});

/**
 * Request Interceptor:
 * Acopla automáticamente el JWT Bearer local a todos los endpoints protegidos, logrando
 * la persistencia de sesión sin cookies nativas.
 */
api.interceptors.request.use(async (config) => {
  const token = localStorage.getItem("accessToken");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

/**
 * Response Interceptor:
 * Evalúa globalmente los retornos 401 (Unauthorized) de Go. Si el token expira o es revocado,
 * destruye la sesión `localStorage` activando React Router protectores pasivos.
 */
api.interceptors.response.use(
  (response) => response,
  async (error) => {
    if (error.response && error.response.status === 401) {
      console.warn("Unauthorized! Redirecting to login.");
      // Solo limpiar localStorage, dejaremos que React Router lo maneje vía estado de auth 
      // o redirigiendo preventivamente sin recargar la app por completo.
      localStorage.removeItem("accessToken");
      localStorage.removeItem("refreshToken");
    }

    return Promise.reject(error);
  },
);

export default api;
